define.alias("shared/components/shared/post/secondary/activity/footer", "settings/components/shared/post/secondary/activity/footer");